/**
 * <fb-countdown data-ends="2026-10-13T23:59:59-03:00">
 *   Conta até data-ends (ISO com fuso), atualizando a cada segundo:
 *   "12h  ·  05m  ·  09s" (Figma node 62:10) ou "8d · 12h · 05m · 09s" quando há dias.
 *   Ao zerar (ou com data vazia/inválida) esconde a faixa [data-fb-promo-bar] inteira.
 */
class FlabomCountdown extends HTMLElement {
  connectedCallback() {
    this.endsAt = this.parseEndsAt(this.dataset.ends);
    this.bar = this.closest('[data-fb-promo-bar]');

    if (!this.endsAt) {
      this.handleOver();
      return;
    }

    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  parseEndsAt(value) {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  tick() {
    const remainingMs = this.endsAt.getTime() - Date.now();

    if (remainingMs <= 0) {
      if (this.timer) clearInterval(this.timer);
      this.handleOver();
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');

    // Figma (node 62:10): "12h  ·  15m  ·  55s", dois espaços ao redor do "·". Com dias,
    // espaço simples para caber na faixa mobile (10px, antes da pílula do CTA).
    // O mesmo formato sai do Liquid em sections/flabom-promo-bar.liquid.
    this.textContent = days
      ? `${days}d · ${hours}h · ${minutes}m · ${seconds}s`
      : `${hours}h  ·  ${minutes}m  ·  ${seconds}s`;
  }

  handleOver() {
    if (this.bar) this.bar.hidden = true;
  }
}

if (!customElements.get('fb-countdown')) {
  customElements.define('fb-countdown', FlabomCountdown);
}
